import { render, staticRenderFns } from "./DocumentsDelete.vue?vue&type=template&id=3269ac5a&scoped=true"
import script from "./DocumentsDelete.vue?vue&type=script&lang=js"
export * from "./DocumentsDelete.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDelete.vue?vue&type=style&index=0&id=3269ac5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3269ac5a",
  null
  
)

export default component.exports